const Style = {

  header:   'mb-5',
  title:    'text-2xl font-bold text-gray-900 m-0 leading-normal',
  subtitle: 'text-base text-gray-500 m-0 leading-normal',

  card:    'bg-white border border-gray-200 rounded-[14px] overflow-hidden',
  toolbar: 'flex justify-between items-center px-5 pt-5',

  // Search
  searchWrap:  'relative w-[480px]',
  searchIcon:  'absolute left-3 top-1/2 -translate-y-1/2 text-gray-300 pointer-events-none flex',
  searchInput: 'w-full pl-11 pr-3 h-[37px] border border-gray-200 rounded-[10px] text-sm text-gray-700 outline-none bg-white box-border',

  // Filter button
  filtersWrap:    'relative',
  filtersBtn:     'flex items-center gap-2 px-3.5 h-[35px] border rounded-[10px] text-sm cursor-pointer transition-colors',
  filtersBtnOff:  'border-gray-200 bg-white text-gray-700 hover:bg-gray-50',
  filtersBtnOn:   'border-blue-600 bg-blue-50 text-blue-600',

  tableWrap: 'p-5',

}

export default Style;
